import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter } from "lucide-react";
import { useShop } from "../../context/ShopContext";
import { Logo } from "./Header";

const cols = [
  ["Shop", [["/shop", "Shop All"], ["/shop?tag=new_arrival", "New Arrivals"], ["/shop?tag=bestseller", "Best Sellers"], ["/shop?offers=1", "Offers"]]],
  ["Help", [["/track-order", "Track Order"], ["/page/faq", "FAQ"], ["/contact", "Contact Us"], ["/page/shipping-policy", "Shipping Policy"]]],
  ["Policies", [["/page/privacy-policy", "Privacy Policy"], ["/page/terms-and-conditions", "Terms & Conditions"], ["/page/return-refund-policy", "Return & Refund"], ["/page/cancellation-policy", "Cancellation"]]],
];

export default function Footer() {
  const { settings } = useShop();
  const s = settings.social || {};
  const socials = [[s.instagram, Instagram, "instagram"], [s.facebook, Facebook, "facebook"], [s.youtube, Youtube, "youtube"], [s.twitter, Twitter, "twitter"]].filter((x) => x[0]);
  return (
    <footer className="bg-[#1B3B2B] text-[#E2EBE2] mt-24" data-testid="site-footer">
      <div className="container-x py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2 space-y-4 max-w-sm">
          <Logo light />
          <p className="text-sm leading-relaxed text-[#E2EBE2]/80">{settings.footer?.about}</p>
          {settings.contact?.email && <p className="text-sm">{settings.contact.email}{settings.contact.phone ? ` · ${settings.contact.phone}` : ""}</p>}
          <div className="flex gap-3">
            {socials.map(([url, Icon, k]) => (
              <a key={k} href={url} target="_blank" rel="noreferrer" data-testid={`footer-social-${k}`} className="p-2 rounded-full border border-white/20 hover:bg-white/10 transition-colors"><Icon className="w-4 h-4" /></a>
            ))}
          </div>
        </div>
        {cols.map(([title, links]) => (
          <div key={title}>
            <p className="text-xs uppercase tracking-[0.2em] text-[#C69C5C] mb-4">{title}</p>
            <ul className="space-y-2.5 text-sm">
              {links.map(([to, l]) => <li key={to}><Link to={to} className="hover:text-white transition-colors">{l}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 text-xs text-[#E2EBE2]/60 flex flex-col sm:flex-row justify-between gap-2">
          <span>{settings.footer?.copyright}</span>
          <span>Trademark Reg. No. 5313444 · seedcosmetics.in</span>
        </div>
      </div>
    </footer>
  );
}
